import KeyboardTracker from './keyboard-tracker.class';

const keyboardTracker = new KeyboardTracker();
let initialized = false;

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          keyboardTracker,
        };
      },
      created() {
        if (!initialized) {
          keyboardTracker.init();
        }
      },
    });
  },
};
